import { render, staticRenderFns } from "./NotificationPopupSuccessOnboarding.vue?vue&type=template&id=433f0a2a&scoped=true&lang=pug"
import script from "./NotificationPopupSuccessOnboarding.vue?vue&type=script&lang=ts"
export * from "./NotificationPopupSuccessOnboarding.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPopupSuccessOnboarding.vue?vue&type=style&index=0&id=433f0a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f0a2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
